import { NumberInput } from 'components/BaseInputs/NumberInput';
import React from 'react';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';

const NUMBER_REGEX = /^[0-9]*\.?[0-9]*$/

export const ConnectedNumberInput = React.forwardRef(
  ({ name, rules, required, id, ...props }, ref) => {
    return (
      <Controller
        name={name}
        rules={{
          required,
          pattern: {
            value: NUMBER_REGEX,
            message: 'Please enter a number',
          },
          ...rules,
        }}
        render={({
          field: { value, onChange, onBlur },
          fieldState: { invalid, error },
        }) => (
          
          <NumberInput
            id={id ?? name}
            fullWidth
            {...props}
            name={name}
            value={value ? String(value) : ''}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            onBlur={onBlur}
            ref={ref}
            error={invalid}
            helperText={error?.message}
            required={Boolean(required || rules?.required)}
          />
        )}
      />
    );
  },
);

ConnectedNumberInput.displayName = 'ConnectedNumberInput';
ConnectedNumberInput.propTypes = {
  name: PropTypes.string.isRequired,
  rules: PropTypes.object,
  required: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool,
};
export default ConnectedNumberInput;
